import React from "react";
import Experience from "../components/Experience/Experience";

const ExperiencePage = () => {
  return (
    <>
      <Experience />
    </>
  );
};

export default ExperiencePage;
